import React from "react";
import { Box, Flex, type FlexProps } from "@chakra-ui/react";
import { CopilotIcon } from "ui/icons";
import { Typewriter, type TypewriterProps } from "ui/typewriter";

function TypewriterContainer({ children, ...props }: FlexProps) {
  return (
    <Flex
      align="center"
      bg="white"
      boxSize="100%"
      border="1.5px solid"
      borderColor="#BD85FA"
      borderRadius="14px"
      gap={{ base: 2, md: 3 }}
      h={{ base: "40px", sm: "52px", md: "60px" }}
      overflow="hidden"
      pos="relative"
      px={{ base: 2, md: 3 }}
      py={{ base: 3, md: 4 }}
      {...props}
    >
      <Box
        bg="radial-gradient(50% 50% at 50% 50%, #BA8BF9 40%, transparent)"
        borderRadius="full"
        boxSize="55px"
        filter="blur(22.5px)"
        opacity={0.3}
        pos="absolute"
        bottom={-4}
        left={-5}
      />
      <Box
        bg="radial-gradient(50% 50% at 50% 50%, #91D4EB 50%, transparent)"
        borderRadius="full"
        h="55px"
        w="97px"
        filter="blur(22.5px)"
        opacity={0.4}
        pos="absolute"
        bottom={-10}
        left={7}
      />
      {children}
    </Flex>
  );
}

type CopilotTypewriterProps = TypewriterProps & {
  /**
   * Additional props to pass to the container Flex component
   */
  containerProps?: FlexProps;
};

export function CopilotTypewriter({ containerProps, ...props }: CopilotTypewriterProps) {
  return (
    <TypewriterContainer {...containerProps}>
      <CopilotIcon boxSize={{ base: "22px", md: "26px", xl: "30px" }} />
      <Typewriter {...props} />
    </TypewriterContainer>
  );
}
